<template>
  <Dropdown
    :key="item.code + '-' + index"
    @on-click="changeMenu"
    transfer
    transfer-class-name="topMenuTransfer"
  >
    <span
      @click="changeMenu(item.pathName)"
      class="topNavItem"
      v-if="item.children == undefined || item.children.length == 0"
    >
      <i :class="item.menuIcon || 'fa fa-image'" :size="iconSize"></i>
      <span class="layout-text">{{item.menuName}}</span>
      <Badge :count="$store.getters.inboxCount" v-if="item.menuCode == 'inbox'"></Badge>
      <Badge
        :count="$store.getters.todoCount"
        v-if="item.menuCode == 'workflow.config.myaffairs.todo'"
      ></Badge>
    </span>
    <span
      :key="item.pathName+'-'+index"
      :name="item.pathName"
      class="topNavItem"
      href="javascript:void(0)"
      v-else
    >
      <i :class="item.menuIcon || 'fa fa-image'" :size="iconSize"></i>
      <span class="layout-text">{{item.menuName}}</span>
      <Icon type="ios-arrow-down"></Icon>
    </span>
    <DropdownMenu slot="list" v-if="item.children && item.children.length > 0">
      <template v-for="child in item.children">
        <subHorizontalMenu :item="child" :key="'menu-'+child.pathName+'-index'"></subHorizontalMenu>
      </template>
    </DropdownMenu>
  </Dropdown>
</template>

<script>
import subHorizontalMenu from './subHorizontalMenu'
export default {
  name: 'horizontalMenu',
  components: {
    subHorizontalMenu
  },
  props: {
    item: Object,
    index: Number
  },
  data () {
    return {
      topMenus: [],
      iconSize: 14
    }
  },
  methods: {
    changeMenu (name) {
      console.log("name", name)
      this.$store.dispatch("menuInfo/updateMenuInfoParams", { key: 'activeName', value: name })
      this.$router.push({ name: name })
      this.$emit('on-change', name)
    },
    getLabel: function (item) {
      console.log("item", item)
      let that = this
      return (h) => {
        return h('Dropdown', {
          props: {
            transfer: true,
          }
        }, [
          h('span', {
            class: 'topNavItem',
            on: {
              click: function () {
                if (item.children == undefined || item.children.length == 0) {
                  that.changeMenu(item.pathName)
                }
              }
            }
          }, [
            h('i', {
              props: {
                size: this.iconSize
              },
              class: item.menuIcon || 'fa fa-image'
            }),
            h('span', { class: "layout-text ml5" }, item.menuName),
            h('Icon', {
              style: {
                display: (item.children && item.children.length > 0) ? 'inline' : 'none'
              },
              props: {
                type: "ios-arrow-down",
              }
            }),
            // that.getSub(item)
            h(subHorizontalMenu, {
              // props: {slot:"list" }
              props: { item: item }
            })
          ])
        ])
      }
    }
  },
  getSub: function (item) {
    return (h) => {
      return h('DropdownMenu', {
        props: { slot: "list" }
      }, [

      ])
    }

  },
  mounted () {
    console.log("rece menus", this.menus)
  }
};
</script>
<style>
.menuContainer {
  height: 100%;
  max-height: 100%;
  width: 100%;
  white-space: nowrap;
  display: flex;
}

.topNavItem {
  font-size: 0.9rem;
  cursor: pointer;
  height: 100%;
  display: block;
  padding: 0 2rem;
}
</style>
